import { clone } from '@jack-henry/frontend-utils/functions';
import { DomainEntity } from '../shared';
import { CompanyAccountModelDto } from '@treasury/api/channel';
import { emptyCompanyAccount as defaultTransferAccount } from '../company/company-account.entity';

export class TransferAccount extends DomainEntity<CompanyAccountModelDto> {
    constructor(dto = clone(defaultTransferAccount)) {
        super(dto);
    }

    public createDefault(): this {
        return new TransferAccount(this.dto) as this;
    }

    public get id() {
        return this.dto.id || 0;
    }

    public get name() {
        return this.dto.name || '';
    }

    public set name(name) {
        this.dto.name = name;
    }

    public get number() {
        return this.dto.number || '';
    }

    public set number(number) {
        this.dto.number = number;
    }

    public get status() {
        return this.dto.status;
    }

    public set status(status) {
        this.dto.status = status;
    }

    public get account() {
        return this.dto.account || undefined;
    }

    public set account(account) {
        this.dto.account = account;
    }

    public get currentBalance() {
        return this.dto.currentBalance || 0;
    }

    public set currentBalance(balance) {
        this.dto.currentBalance = balance;
    }

    public get collectedBalance() {
        return this.dto.collectedBalance || 0;
    }

    public set collectedBalance(balance) {
        this.dto.collectedBalance = balance;
    }

    public get availableBalance() {
        return this.dto.availableBalance || 0;
    }

    public set availableBalance(balance) {
        this.dto.availableBalance = balance;
    }

    public get type() {
        return this.dto.type || '';
    }

    public set type(type) {
        this.dto.type = type;
    }

    public get perTransactionLimit() {
        return this.dto.perTransactionLimit || 0;
    }

    public set perTransactionLimit(limit) {
        this.dto.perTransactionLimit = limit;
    }

    public get dailyLimit() {
        return this.dto.dailyLimit || 0;
    }

    public set dailyLimit(limit) {
        this.dto.dailyLimit = limit;
    }

    public get cifNumber() {
        return this.dto.cifNumber;
    }

    public set cifNumber(cifNumber) {
        this.dto.cifNumber = cifNumber;
    }

    public get isDeleted() {
        return this.dto.isDeleted || false;
    }

    public set isDeleted(isDeleted) {
        this.dto.isDeleted = isDeleted;
    }

    public get showAccountNickName() {
        return this.dto.showAccountNickName || false;
    }

    public set showAccountNickName(showAccountNickName) {
        this.dto.showAccountNickName = showAccountNickName;
    }

    public get accountDisplayLabel() {
        return this.dto.accountDisplayLabel || '';
    }

    public set accountDisplayLabel(accountDisplayLabel) {
        this.dto.accountDisplayLabel = accountDisplayLabel;
    }

    public get transferAmount() {
        return this.dto.transferAmount || 0;
    }

    public set transferAmount(transferAmount) {
        this.dto.transferAmount = transferAmount;
    }

    public get transferMemo() {
        return this.dto.transferMemo || undefined;
    }

    public set transferMemo(transferMemo) {
        this.dto.transferMemo = transferMemo;
    }

    public get loanPaymentAmountDue() {
        return this.dto.loanPaymentAmountDue || 0;
    }

    public set loanPaymentAmountDue(loanPaymentAmountDue) {
        this.dto.loanPaymentAmountDue = loanPaymentAmountDue;
    }

    public get loanPaymentDueDate() {
        return this.dto.loanPaymentDueDate || undefined;
    }

    public set loanPaymentDueDate(loanPaymentDueDate) {
        this.dto.loanPaymentDueDate = loanPaymentDueDate;
    }

    public get allowLoanPaymentPastDue() {
        return this.dto.allowLoanPaymentPastDue || false;
    }

    public set allowLoanPaymentPastDue(allowLoanPaymentPastDue) {
        this.dto.allowLoanPaymentPastDue = allowLoanPaymentPastDue;
    }

    public get accountUniqueId() {
        return this.dto.accountUniqueId || '';
    }

    public set accountUniqueId(accountUniqueId) {
        this.dto.accountUniqueId = accountUniqueId;
    }

    public get transferAccountId() {
        return this.dto.id || 0;
    }

    public set transferAccountId(id) {
        this.dto.id = id;
    }

    public get updatedBy() {
        return this.dto.updatedBy || '';
    }

    public set updatedBy(user) {
        this.dto.updatedBy = user;
    }

    public get updatedDate() {
        return this.dto.updatedDate || '';
    }

    public set updatedDate(updatedDate) {
        this.dto.updatedDate = updatedDate;
    }
}
